import React, { ReactNode, useEffect, useState } from 'react';
import ContentProvider from '../providers/content/provider';
import DeviceProvider from '../providers/device-provider';
import SidebarProvider from '../providers/sidebar-provider';
import UserProvider from '../providers/user-provider';
import getLayout from './getLayout';
import CartProvider from '../providers/cart-provider';
import CheckoutProvider from '../container/checkout/provider';
import { WebAnalytics } from '../container/analytics/webAnalytics';
import { TyRegion } from '../types';
import { REGION_MAP } from '../utils/regionUtils';
import SEO from '../container/seo';
import AlertProvider from '../providers/alert-provider';
export default function GlobalLayout(props: { children: ReactNode; location: any }): JSX.Element {
  const [isMobile, setIsMobile] = useState(true);
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const isLoggedIn = sessionStorage.getItem('isLoggedIn');
  useEffect(() => {
    window.React = React;
    const resize = () => {
      setIsMobile(window.innerWidth < 1280);
    };
    resize();

    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      const url = window.location.href;
      const region = url.split('/')[3];
      const currentUrl = REGION_MAP[region?.toUpperCase() as TyRegion];
      sessionStorage.setItem('region', currentUrl);
    }
  }, [isLoggedIn]);

  return (
    <DeviceProvider value={{ isMobile, setIsMobile }}>
      <ContentProvider>
        <AlertProvider>
          <UserProvider {...props}>
            <SidebarProvider value={{ isSideBarOpen, setIsSideBarOpen }}>
              <CartProvider>
                <CheckoutProvider>
                  <SEO />
                  {getLayout(props)}
                </CheckoutProvider>
              </CartProvider>
            </SidebarProvider>
          </UserProvider>
        </AlertProvider>
      </ContentProvider>
    </DeviceProvider>
  );
}
